
import { useEffect, useState } from "react"
import { GET_FORM_LIST, GET_FORM_DETAILS, FORM_FILL } from "../../../repository/patient-form"
import { toast } from "react-toastify"
import useReduxStore from "../../../hooks/useReduxStore"
import { useLocation } from "react-router-dom"
import moment from "moment-timezone"

const UseForm = () => {
    const { selector: user } = useReduxStore("auth")
    const [spinner, setSpinner] = useState(false)
    const { selector: PatientData } = useReduxStore("PatientData")
    const location = useLocation();
    const [totalCount, settotalCount] = useState(0)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: 1 })
    const [listData, setListData] = useState([])
    const [filter, setFilter] = useState({
        search: '',
        status: [{ title: 'All', value: 'ALL' }]
    })
    const [filterOpen, setFilterOpen] = useState(null)
    const [viewFormModal, setViewFormModal] = useState({ data: null, open: false })

    const [viewFieldsArry, setViewFieldsArry] = useState([]);

    const [fields, setFields] = useState({})
    const isFormPage = location?.pathname === "/form"


    useEffect(() => {
        form_List()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controller])

    const form_List = async () => {
        try {
            const payload = {
                count: controller.rowsPerPage ,
                page: controller.page ,
                patientId: isFormPage ? user?.user_id : PatientData?.id,
                status: isFormPage ? (filter?.status?.[0]?.value === "ALL" ? null : filter?.status?.[0]?.value) : "FILLED",
                searchName: filter?.search
            }
            setSpinner(true)
            let response = await GET_FORM_LIST(payload)
            setListData(response?.data)
            setFilterOpen(null)
            settotalCount(response.count)

        } catch (error) {
            toast.error(error?.message)
            setListData([])
            setFilterOpen(null)
            settotalCount(0)
        }
        setSpinner(false)
    }
    const form_Details = async (id) => {
        try {
            setSpinner(true)
            let response = await GET_FORM_DETAILS(id)
            const formData = response?.data?.formData;

            // Map API data to fields state
            const initialFields = formData.reduce((acc, field) => {
                if (field.answer !== null) {
                    acc[field.fieldId] = field.answer;
                }
                return acc;
            }, {});

            // Set the state with initial fields and form data for rendering
            setFields(initialFields);
            setViewFieldsArry(formData);

            // setViewFieldsArry(response?.data?.formData);

        } catch (error) {
            toast.error(error?.message)
            // setListData([])
        }
        setSpinner(false)
    }
    const handleInputChange = (event, fieldId) => {
        const { value } = event.target;
        setFields((prevProps) => ({ ...prevProps, [fieldId]: value }));
    };

    const handleDateChange = (date, fieldName) => {
        setFields((prevData) => ({
            ...prevData,
            [fieldName]: date,
        }));
    };
    const handleRadioChange = (e, fieldId) => {
        setFields(prevFields => ({
            ...prevFields,
            [fieldId]: e.target.value
        }));
    };
    // const handleCheckboxChange = (e, option, fieldId) => {
    //     setFields(prevFields => {
    //         const currentValues = prevFields[fieldId] || [];
    //         const updatedValues = e.target.checked
    //             ? [...currentValues, option.optionId]
    //             : currentValues.filter(id => id !== option.optionId);

    //         return {
    //             ...prevFields,
    //             [fieldId]: updatedValues
    //         };
    //     });
    // };

    const handleCheckboxChange = (e, option, fieldId) => {
        setFields(prevFields => {
            const currentValues = Array.isArray(prevFields[fieldId]) ? prevFields[fieldId] : [];
            const updatedValues = e.target.checked
                ? [...currentValues, option.optionId]
                : currentValues.filter(id => id !== option.optionId);
            return {
                ...prevFields,
                [fieldId]: updatedValues
            };
        });
    };


    const handleTextChange = (e, fieldId) => {
        setFields(prevFields => ({
            ...prevFields,
            [fieldId]: e.target.value
        }));
    };

    const handleSubmit = async () => {
        const answers = Object.keys(fields).map(fieldId => {
            const field = viewFieldsArry.find(f => f.fieldId === parseInt(fieldId));
            let answer;

            if (field?.type === 'CheckBox') {
                // For CheckBox, handle multiple selected values
                answer = fields[fieldId] || "";
            } else if (field?.type === 'Multiple Choice') {
                // For Multiple Choice, handle selected values
                answer = Number(fields[fieldId]) || [];
            }
            else if (field?.type === 'Date') {
                // Format date fields to desired format (e.g., 'YYYY-MM-DD')
                answer = fields[fieldId] ? moment(fields[fieldId]).format('YYYY-MM-DD') : '';
            }

            else {
                // For other types, handle single value
                answer = fields[fieldId] || '';
            }

            return {
                fieldId: parseInt(fieldId),
                answer: answer
            };
        });

        // Construct the submission data
        const submissionData = {
            id: viewFormModal?.data?.id,
            filledPercentage: calculateFilledPercentage(),
            answers: answers
        };
        try {
            setSpinner(true)
            let response = await FORM_FILL(submissionData)
            setViewFieldsArry(response?.data?.formData);
            toast.success(response?.message)
            setViewFormModal({ data: null, open: false })
            form_List()

        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    };

    // Example function to calculate filled percentage
    const calculateFilledPercentage = () => {
        const totalFields = viewFieldsArry.length;

        const filledFields = Object.keys(fields).reduce((count, fieldId) => {
            const answer = fields[fieldId];
            if (Array.isArray(answer) ? answer.length > 0 : answer !== "" && answer !== null) {
                return count + 1;
            }
            return count;
        }, 0);

        // Calculate the filled percentage
        return totalFields > 0 ? (filledFields / totalFields) * 100 : 0;
    };

    const resetFilter = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage, searchPage: 1 }))
        setFilter((pre) => ({ ...pre, search: '' }))
    }

    const ApplyFilter = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
    }


    return {
        methods: {
            setFilter,
            form_List,
            setFilterOpen,
            form_Details,
            setViewFormModal,
            handleTextChange,
            handleSubmit,
            settotalCount,
            setController,
            handleDateChange,
            handleRadioChange,
            handleCheckboxChange,
            setViewFieldsArry,

            // -----------------------Form methods ---------------
            setFields,
            handleInputChange,
            resetFilter,
            ApplyFilter
        },
        data: {
            spinner,
            listData,
            filter,
            filterOpen,
            viewFormModal,
            controller,
            totalCount,
            viewFieldsArry,
            fields,
        }
    }
}

export default UseForm
